import { SPOTTER_STRINGS } from "../strings";
import { ControlRoomJob } from "./service";

/**
 * The Job column's primary two-line label (Monday 12937644849) — replaces the raw job id as the
 * first thing a person reads. Precedence: a resolved `target` name (Films Ground/Top Films/
 * saved-search/assets) first, then the five game/practice modes' `gameLabel`, then the job id
 * itself as the last-resort fallback — never blank, never an empty second line, never "Unknown".
 */
export interface RowLabel {
  primary: string;
  secondary?: string;
  /** `true` only for the job-id fallback — drives the monospace treatment `JobId` used to give
   *  every row, now reserved for when the primary line genuinely IS a job id. */
  isJobId: boolean;
  /** Collection/saved-search only — deep link into iconik's own web UI. */
  url?: string;
}

export function resolveRowLabel(job: ControlRoomJob): RowLabel {
  const { target, gameLabel, jobId } = job;
  if (target?.kind === "assets") {
    return {
      primary: SPOTTER_STRINGS.controlRoom.assetsCount(target.assetCount ?? 0),
      isJobId: false,
    };
  }
  if (
    target &&
    (target.kind === "collection" || target.kind === "saved_search") &&
    target.name
  ) {
    return {
      primary: target.name,
      secondary:
        target.kind === "collection"
          ? target.parentName
          : SPOTTER_STRINGS.controlRoom.savedSearchLabel,
      isJobId: false,
      url: target.url,
    };
  }
  if (gameLabel) {
    return {
      primary: gameLabel.primary,
      secondary: gameLabel.secondary,
      isJobId: false,
    };
  }
  return { primary: jobId, isJobId: true };
}
